function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    let details = event.currentTarget.closest('details');
    event.currentTarget.setAttribute('aria-expanded', !details.hasAttribute('open'));
    let accordion = details.closest('.accordion');
    if (accordion) {
      accordion.classList[!details.hasAttribute('open') ? 'add' : 'remove']('accordion-open');
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
  elementToFocus.dispatchEvent(new Event('input', { bubbles: true }));
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    //document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    let slideshow = this.querySelector('.slideshow');
    let disableOnMobile = JSON.parse(slideshow.dataset.disableSlideshowMobile);
    let isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && disableOnMobile) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();

    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: this.currentVariant } }));

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.toggleAddButton(!this.currentVariant.available);
    }

    custom_afterpay(document.querySelector('.price + square-placement'),'left');
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.querySelector(`#price-${this.dataset.section} .price`);
        const source = html.querySelector(`#price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section} .price`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      //if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      // addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

Shopify.theme.utils = {
  isValidEmail(value) { 
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  },
  submitNewsletterForm(e) {
    let utils = this;
    let $form = e.currentTarget.closest('form.form-newsletter');
    let $email = $form.querySelector('input[type=email]');
    let submitButton = $form.querySelector('button[type=submit]');
    let email = $email.value;
  
    if (!utils.isValidEmail(email)) {
      if ($email.value !== '') {
        // $email.value = '';
        // $email.classList.add("devClassValid");
        $email.disabled = false;
        // $email.placeholder = 'PLEASE ENTER A VALID EMAIL';
        var element2 = $form.querySelector(".newsletter-form-buttons"); 
        submitButton.classList.remove("devClassSubmit");
        var element = $form.querySelector(".newsletter-form__field-wrapper");
        element.classList.add("devClassValid");
  
      } else {
        $email.placeholder = 'ENTER YOUR EMAIL ADDRESS';
        $email.classList.remove("devClassValid");
        submitButton.classList.remove("devClassSubmit");
        var element = $form.querySelector(".newsletter-form__field-wrapper"); 
        element.classList.remove("devClassValid");
      }
      return;
    }
  
    utils.formSubmitAjax($form, () => {
      utils.newsletterSubmitSuccess($form);
    });
  },  
  formSubmitAjax(form, callback) { 
    fetch(form.getAttribute('action'), {
      method: form.getAttribute('method'),
      mode: 'no-cors',
      body: new FormData(form)
    })
      .then(res => res.text())
      .then(callback)
      .catch(console.error);
  },
  newsletterSubmitSuccess($form) {
    let $email = $form.querySelector('input[type=email]');
    let submitButton = $form.querySelector('button[type=submit]');
    let placeholder = $email.placeholder;
    $email.value = '';
    $email.placeholder = 'THANK YOU FOR JOINING';
    $email.classList.remove("devClassValid");
    $email.disabled = true;
  
    var element2 = $form.querySelector(".newsletter-form-buttons");
    submitButton.classList.add("devClassSubmit");
  
    var element = $form.querySelector(".newsletter-form__field-wrapper");
    element.classList.remove("devClassValid");
  
    let devButton = document.querySelector('#MainContent .shopify-section:last-child');
    if(devButton){
    devButton.classList.add("devDispAllColBtn");
    }
    // setTimeout(() => {
    //   $email.placeholder = placeholder;
    // }, 1000);
  },
   
  openSearchModal(e) {
    e.preventDefault();
    let $searchIcon = document.querySelector('.header__icons .header__icon--search');
    $searchIcon.closest('details-modal').classList.add('mobile-search-toggle');
    let $details = $searchIcon.closest('details');
    $details.setAttribute('open', 'true');
    $details.querySelector('input[name=query]').focus();

    // close open menu
    document.querySelector('.header__icon--menu').click();

    let $search_input = document.querySelector('.mobile-search-toggle input[type=search]');
    $search_input.focus();
    $search_input.dispatchEvent(new Event('input', { bubbles: true }));
  },
  getCartJS() { 
    return fetch('/cart.js').then(res => res.json()).catch(console.error);
  },
  openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
  },
  updateCartItemQuantity(itemKey, qty) {
    let cartUpdateUrl = '/cart/update.js';
    let updates = {};
    updates[itemKey] = qty;

    return fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    });
  },
  getLocation() {
    const session_ip_loc = 'LOC';
    
    return new Promise((resolve) => {
      fetch('/browsing_context_suggestions.json')
      .then((res) => res.json())
      .then((res) => {
        sessionStorage.setItem(session_ip_loc, JSON.stringify(res));
        resolve(res);
      });
    });
  },
  getShippingProgressSettings() {
    let $shippingProgressBar = document.querySelector('.cart-shipping-progress');
    let shippingProgress = {};
    if ($shippingProgressBar) {
      shippingProgress = {
        threshold_usa: parseFloat($shippingProgressBar.dataset.thresholdUsa) * 100,
        threshold_can: parseFloat($shippingProgressBar.dataset.thresholdCan) * 100,
        threshold_int: parseFloat($shippingProgressBar.dataset.thresholdInt) * 100
      };
    }

    return shippingProgress;
  },
  getFreeShippingProgress(shippingProgressSettings, cart) {
    let checkProgress = (location) => {
      let progress = {
        progressPercent: 0,
        remainingAmount: `${window.cartStrings.currency_symbol}0`,
        eligible: false
      };

      if (!shippingProgressSettings || !cart) {
        return progress;
      }

      let cart_total_price = cart.total_price;
      let is_USA = location.detected_values.country.handle == 'US';
      let is_CAN = location.detected_values.country.handle == 'CA';
      let is_INT = !is_USA && !is_CAN;
      let freeShippingThreshold;
      if (is_USA) {
        freeShippingThreshold = shippingProgressSettings.threshold_usa;
      }
      else if (is_CAN) {
        freeShippingThreshold = shippingProgressSettings.threshold_can;
      }
      else if(is_INT) {
        freeShippingThreshold = shippingProgressSettings.threshold_int;
      }
      freeShippingThreshold = freeShippingThreshold * window.Shopify.currency.rate;
      let progressPercent = ((cart_total_price / freeShippingThreshold) * 100).toFixed(2);
      progressPercent = (progressPercent > 100) ? 100 : progressPercent;
      progress.progressPercent = progressPercent;

      let remainingAmount = freeShippingThreshold - cart_total_price;
      remainingAmount = Math.round(remainingAmount); // Round to the nearest whole number
      remainingAmount = Shopify.formatMoney(remainingAmount, `${window.cartStrings.currency_symbol}{{amount}}`);
      progress.remainingAmount = remainingAmount;     

      let eligible = cart_total_price > freeShippingThreshold
      progress.eligible = eligible;

      // check if only gift item in cart
      let giftCard_items = cart.items.filter(item => item.product_title == 'Gift card');
      let giftCard_items_qty = giftCard_items.reduce((sum, item) => sum + item.quantity, 0);
      if (cart.item_count > 0 && cart.item_count == giftCard_items_qty) {
        progress = {
          progressPercent: 100,
          remainingAmount: `${window.cartStrings.currency_symbol}0`,
          eligible: true
        };        
      }

      return progress;
    }

    return new Promise((resolve, reject) => {
      this.getLocation()
        .then((location) => {
          resolve(checkProgress(location));
        })
        .catch(reject);
    });
  },
  stringToHTML(text) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(text, 'text/html');
    return doc.body;
  },
  submitBackinStockForm(e) {
    
    e.preventDefault();
    let $form = e.currentTarget.closest('.notify-form');
    let $email = $form.querySelector('input[type=email]');
    let email = $email.value;
    let $sizes = $form.querySelectorAll('input:checked');

    if (!$sizes.length) {
      $form.querySelector('.size-error').classList.remove('tw-hidden');
      return;
    }
    $form.querySelector('.size-error').classList.add('tw-hidden');

    Array.from($sizes).forEach(($size) => {
      let product_id = $size.dataset.product;
      let variant_id = $size.dataset.variant;

      BIS.create(email, variant_id, product_id).then((data) => {
        var msg = '';
        if (data.status == 'OK') {
          localStorage.setItem('bis_email',email);
          // msg = data.message;
          msg = 'THANK YOU! AN EMAIL WILL BE SENT WHEN THIS ITEM RESTOCKS.'
          $form.querySelector('.bis-error_email').innerHTML = '';
            $email.value = ''; // Clear the email input field
            $email.placeholder = msg; // Clear the email input field
            // $emailplc.value = msg;
            $email.readOnly = true;
            e.target.innerText="SENT";
        } 
        else {
          for (var k in data.errors) {
            msg += (data.errors[k].join());
            $form.querySelector('.bis-error_email').innerHTML = msg;
          }
        }
       
      });
    });
  },
  submitBackinStockFormnum(e) {
    e.preventDefault();
    let $form = e.currentTarget.closest('.notify-form');
    let $tel = $form.querySelector('input[type=tel]');
    let tel = $tel.value;
    let $sizes = $form.querySelectorAll('input:checked');
    let $phoneerror = $form.querySelector('.bis-error_num');
    if (!$sizes.length) {
      $form.querySelector('.size-error').classList.remove('tw-hidden');
      return;
    }
    $form.querySelector('.size-error').classList.add('tw-hidden');
    let countryCode = sessionStorage.getItem('cntryCode');
    if (tel !== '' && countryCode) {
        tel = countryCode + tel;
    }
    else{
      $form.querySelector('.bis-error_num').innerHTML = "Please Enter your phone Number";
    }
    Array.from($sizes).forEach(($size) => {
      let product_id = $size.dataset.product;
      let variant_id = $size.dataset.variant;
      BIS.create(null, variant_id, product_id, { phone_number: tel }).then((data) => {
        var msg = '';
        if (data.status == 'OK') {
          let countryCode = sessionStorage.getItem('cntryCode');
          localStorage.setItem('bis_tel',$tel.value);
          localStorage.setItem('cntryCode',countryCode);
          // msg = data.message;
          msg = 'THANK YOU! TEXT WILL BE SENT WHEN THIS ITEM RESTOCKS.'
            $tel.value = ''; // Clear the tel input field
            $tel.readOnly = true;
            $tel.placeholder = msg; // Clear the email input field
            $form.querySelector('.bis-error_num').innerHTML = '';
            $form.querySelector('.flags_gropdown').style.display = "none";
            e.target.innerText="SENT";
            
        } 
        else {
          for (var k in data.errors) {
            msg += (data.errors[k].join());
            $form.querySelector('.bis-error_num').innerHTML = msg;
          }
        }
             
      });
    });
  },
 
 submitBackinStockFormcomon(e) {
  e.preventDefault();
  let $form = e.currentTarget.closest('.notify-form');
  let $email = $form.querySelector('input[type=email]');
  let $tel = $form.querySelector('input[type=tel]');
  let $sizes = $form.querySelectorAll('input:checked');
  let $emailerror = $form.querySelector('.bis-error_email');
  let $phoneerror = $form.querySelector('.bis-error_num');
  if (!$sizes.length) {
    $form.querySelector('.size-error').classList.remove('tw-hidden');
    return;
  }
   // Check if email or phone is provided
   if (!$email.value && !$tel.value) {
    msgPhone = "PLEASE ENTER PHONE";
    msgEmail = "PLEASE ENTER EMAIL";
    $phoneerror.innerHTML = msgPhone;
    $emailerror.innerHTML = msgEmail;
    return;
  }
  $form.querySelector('.size-error').classList.add('tw-hidden');
  Array.from($sizes).forEach(($size) => {
    let product_id = $size.dataset.product;
    let variant_id = $size.dataset.variant;

    if ($email.value && $tel.value) {
      let tel = $tel.value;
      let countryCode = sessionStorage.getItem('cntryCode');
    if (tel !== '' && countryCode) {
        tel = countryCode + tel;
    }
      else{
        $form.querySelector('.bis-error_num').innerHTML = "Please Enter your phone Number";
      }
      console.log('Cell sent');
      Promise.all([
        BIS.create($email.value, variant_id, product_id),
        BIS.create(null, variant_id, product_id, { phone_number: tel })
      ]).then(([emailResponse, phoneResponse]) => {
        console.log(emailResponse);
        console.log(phoneResponse);
        var emailMsg = '';
        e.target.innerText = "SENT";
        if (emailResponse.status == 'OK') {
          $phoneerror.innerHTML = '';
    $emailerror.innerHTML = '';
          localStorage.setItem('bis_email', $email.value);
          emailMsg = "THANK YOU! AN EMAIL WILL BE SENT WHEN THIS ITEM RESTOCKS.";
          $email.value = '';
          $email.readOnly = true;
          $email.placeholder = emailMsg;
          $form.querySelector('.bis-error_email').innerHTML = '';
          e.target.innerText = "SENT";
        } else {
          for (var k in emailResponse.errors) {
            emailMsg += (emailResponse.errors[k].join());
          }
          e.target.innerText = "SUBMIT";
          $email.closest('.notify-form').querySelector('.bis-error_email').innerHTML = emailMsg;
        }

        var phoneMsg = '';
        if (phoneResponse.status == 'OK') {
          $phoneerror.innerHTML = '';
          $emailerror.innerHTML = '';
          let countryCode = sessionStorage.getItem('cntryCode');
          localStorage.setItem('bis_tel',$tel.value);
          localStorage.setItem('cntryCode',countryCode);
          phoneMsg = "THANK YOU! TEXT WILL BE SENT WHEN THIS ITEM RESTOCKS.";
          $tel.value = '';
          $tel.readOnly = true;
          $tel.placeholder = phoneMsg;
          $form.querySelector('.bis-error_num').innerHTML = '';
          $form.querySelector('.flags_gropdown').style.display = "none";
          e.target.innerText = "SENT";
        } else {
          for (var k in phoneResponse.errors) {
            phoneMsg += (phoneResponse.errors[k].join());
          }
          e.target.innerText = "SUBMIT";
          $tel.closest('.notify-form').querySelector('.bis-error_num').innerHTML = phoneMsg;
        }
      });
    } else {
      let promise;
      if ($email.value) {
        console.log('Cell sent1');
        promise = BIS.create($email.value, variant_id, product_id);
        promise.then((emailResponse) => {
          var emailMsg = '';
          if (emailResponse.status == 'OK') {
            $phoneerror.innerHTML = '';
            $emailerror.innerHTML = '';
            localStorage.setItem('bis_email', $email.value);
            emailMsg = "THANK YOU! AN EMAIL WILL BE SENT WHEN THIS ITEM RESTOCKS.";
            $email.value = '';
            $email.readOnly = true;
            $email.placeholder = emailMsg;
            e.target.innerText = "SENT";
          } else {
            for (var k in emailResponse.errors) {
              emailMsg += (emailResponse.errors[k].join());
            }
            $email.closest('.notify-form').querySelector('.bis-error_email').innerHTML = emailMsg;
          }
        });
      } else {
        console.log('Cell sent333');
        let tel = $tel.value;
      if (tel !== '') {
        let countryCode = sessionStorage.getItem('cntryCode');
        tel = countryCode + tel;
      }
      else{
        $form.querySelector('.bis-error_num').innerHTML = "Please Enter your phone Number";
      }
        promise = BIS.create(null, variant_id, product_id, { phone_number: tel });
        promise.then((phoneResponse) => {
          var phoneMsg = '';
          if (phoneResponse.status == 'OK') {
            $phoneerror.innerHTML = '';
            $emailerror.innerHTML = '';
            phoneMsg = "THANK YOU! TEXT WILL BE SENT WHEN THIS ITEM RESTOCKS.";
            let countryCode = sessionStorage.getItem('cntryCode');
            localStorage.setItem('bis_tel',$tel.value);
            localStorage.setItem('cntryCode',countryCode);
            $tel.value = '';
            $tel.readOnly = true;
            $tel.placeholder = phoneMsg;
            e.target.innerText = "SENT";
          } else {
            for (var k in phoneResponse.errors) {
              phoneMsg += (phoneResponse.errors[k].join());
            }
            $tel.closest('.notify-form').querySelector('.bis-error_num').innerHTML = phoneMsg;
          }
        });
      }
    }
  });
},
  checkIfMobileView() {
    return window.matchMedia('(max-width: 749px)').matches;
  }
}

/* Shopify Format Money using JS */
!(function () {
  "undefined" == typeof window.Shopify && (window.Shopify = {}),
    (Shopify.each = function (t, e) {
    for (var n = 0; n < t.length; n++) e(t[n], n);
  }),
    (Shopify.map = function (t, e) {
    for (var n = [], i = 0; i < t.length; i++) n.push(e(t[i], i));
    return n;
  }),
    (Shopify.arrayIncludes = function (t, e) {
    for (var n = 0; n < t.length; n++) if (t[n] == e) return !0;
    return !1;
  }),
    (Shopify.uniq = function (t) {
    for (var e = [], n = 0; n < t.length; n++) Shopify.arrayIncludes(e, t[n]) || e.push(t[n]);
    return e;
  }),
    (Shopify.isDefined = function (t) {
    return "undefined" != typeof t;
  }),
    (Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1);
  }),
    (Shopify.extend = function (t, e) {
    function n() {}
    (n.prototype = e.prototype), (t.prototype = new n()), (t.prototype.constructor = t), (t.baseConstructor = e), (t.superClass = e.prototype);
  }),
    (Shopify.locationSearch = function () {
    return window.location.search;
  }),
    (Shopify.locationHash = function () {
    return window.location.hash;
  }),
    (Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t);
  }),
    (Shopify.urlParam = function (t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "));
  }),
    (Shopify.newState = function (t, e) {
    var n;
    return (
      (n = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e),
      n + Shopify.locationHash()
    );
  }),
    (Shopify.setParam = function (t, e) {
    Shopify.replaceState(Shopify.newState(t, e));
  }),
    (Shopify.money_format = "${{amount}}"),
    (Shopify.formatMoney = function (t, e) {
    function n(t, e) {
      return "undefined" == typeof t ? e : t;
    }
    function i(t, e, i, r) {
      if (((e = n(e, 2)), (i = n(i, ",")), (r = n(r, ".")), isNaN(t) || null == t)) return 0;
      t = (t / 100).toFixed(e);
      var o = t.split("."),
          s = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
          a = o[1] ? r + o[1] : "";
      return s + a;
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
        o = /\{\{\s*(\w+)\s*\}\}/,
        s = e || this.money_format;
    switch (s.match(o)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        r = i(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'");
    }
    return s.replace(o, r);
  })
})();


// Function to show the element with ID 'RichText--template--16220394291379__c35c2e89-7fbe-4258-8f0e-cce817adc188'
function showElement() {
  var elementToDisplay = document.querySelector('#MainContent .shopify-section:last-child');
  if (elementToDisplay) {
    elementToDisplay.style.display = 'block';
  }
}

// Callback function for the MutationObserver
function mutationCallback(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (const addedNode of mutation.addedNodes) {
        if (addedNode.classList && addedNode.classList.contains('success-container')) {
          showElement(); // Call the function to show the element when .success-container is added
        }
      }
    }
  }
}

// Create a MutationObserver instance
const observer = new MutationObserver(mutationCallback);

// Start observing the DOM for changes to the descendants of the body element
observer.observe(document.body, { childList: true, subtree: true });

$(document).on('click', '.product-grid-item', function() {
    localStorage.setItem('item_top',window.pageYOffset);
    localStorage.setItem('pid', $(this).attr('data-pid'));
    localStorage.setItem('items_on_load',$(this).index()+1);
    localStorage.setItem('ppp',ppp);
});
function collectionPageEvents() {
  var addToCartBtn = document.getElementById('addToCartAndCheckoutBtn');
  if (addToCartBtn ){
    addToCartBtn.classList.remove("loading");
  }
const bisStockMediabutton = document.querySelectorAll('.devColOptionSize.devMobileQuickShop.notify_options');  
bisStockMediabutton.forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default action
    sessionStorage.setItem('outOfstock', 'true');
    sessionStorage.setItem('BIS_img_route' , 'false');
  });
 
});
const bisStockMediaElements = document.querySelectorAll('.card-wrapper.bis_Stock .card__media');  
// Add event listener for hover on each card__media element
bisStockMediaElements.forEach(element => {
    element.addEventListener('click', function() { 
        sessionStorage.setItem('BIS_img_route', "true");

    });
});
}

collectionPageEvents();
 
  
function countryCodesSelector(){
  var bisEmail = localStorage.getItem('bis_email');
  if (bisEmail) {
    document.querySelectorAll('.notify-form-wrap input[type="email"]').forEach(function(input) {
      input.value = bisEmail;
    });
  }

  // Retrieve telephone from localStorage and populate input fields
  var bisTel = localStorage.getItem('bis_tel');
  if (bisTel) {
    document.querySelectorAll('.notify-form-wrap input[type="tel"]').forEach(function(input) {
      input.value = bisTel;
    });
  }
  const flagspans = document.querySelectorAll('.flags_gropdown');
  let $tel = document.querySelector('input[type=tel]');

  // Function to adjust the width of the select element
  const adjustSelectWidth = (select, value) => {
    let width;
    if (value.length === 2) {
      width = 25;
    } else if (value.length === 3) {
      width = 30;
    } else if (value.length === 4) {
      width = 36;
    }
    select.style.width = `${width}px`;
  };

  const cntryCode = localStorage.getItem('cntryCode') || '1'; // Default to '1' (US) if not available

  flagspans.forEach((span) => {
    let select = span.querySelector('select');
    if (!select) {
      select = document.createElement('select');
      span.appendChild(select);
    }

    countryCodes.forEach((country) => {
      const option = document.createElement('option');
      option.value = country.mobileCode;
      option.text = country.mobileCode + " " + country.name;
      if (country.code === 'US' && $tel.value == '' ) {
        option.setAttribute('selected', 'selected');
        sessionStorage.setItem('cntryCode', country.mobileCode);
      }
      else{
        if(country.mobileCode == cntryCode){
          option.setAttribute('selected', 'selected');
          adjustSelectWidth(select, cntryCode);
        }
      }
      select.appendChild(option);
    });

    select.addEventListener('change', (e) => {
      const value = e.target.value;
      sessionStorage.setItem('cntryCode', value);
      adjustSelectWidth(select, value);
    });
  });
}

countryCodesSelector();
  var addToCartBtn = document.getElementById('addToCartAndCheckoutBtn');
  addToCartBtn.classList.remove("loading");
